
import React from 'react';
import { AutomationContent } from './automation/components/AutomationContent';

const Automation: React.FC = () => {
  return <AutomationContent />;
};

export default Automation;
